import { render, staticRenderFns } from "./AllowancesPlanAdd.vue?vue&type=template&id=75e057c0&scoped=true&"
import script from "./AllowancesPlanAdd.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e057c0",
  null
  
)

export default component.exports